
import React, { useEffect, useState } from "react";
import { CCarousel, CCarouselItem, CImage } from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

export const Slider = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 700);
  const [mobileSlides, setMobileSlides] = useState([]);
  const [desktopSlides, setDesktopSlides] = useState([]);

  useEffect(() => {
    const fetchMobileSlides = async () => {
      try {
        const records = await pb.collection("Mobile_Slides").getFullList();
        setMobileSlides(records);
      } catch (error) {
        console.error("Error fetching mobile slides:", error);
      }
    };

    const fetchDesktopSlides = async () => {
      try {
        const records = await pb.collection("Desktop_Slides").getFullList();
        setDesktopSlides(records);
      } catch (error) {
        console.error("Error fetching desktop slides:", error);
      }
    };

    fetchMobileSlides();
    fetchDesktopSlides();

    const handleResize = () => {
      setIsWideScreen(window.innerWidth >= 700);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const slides = isWideScreen ? desktopSlides : mobileSlides;

  return (
    <div className="w-100 flex justify-center items-center">
      <div className="w-full py-8 px-4 md:px-20 lg:py-12 min-h-[400px]">
        <div className="max-w-7xl mx-auto">
          <CCarousel controls indicators dark className="rounded-2xl shadow-xl">
            {slides.map((slide, index) => (
              <CCarouselItem key={index}>
                <CImage
                  className="d-block w-full h-auto object-cover md:p-10"
                  src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${slide.collectionId}/${slide.id}/${slide.field}`}
                  alt={slide.title}
                />
              </CCarouselItem>
            ))}
          </CCarousel>
        </div>
      </div>
    </div>
  );
};
